import { AsyncState } from '@hglobal/common';

import { GetCategoriesRes, GetTipsRes, SendMessageRes } from '../models';

export const supportFeatureKey = 'Support';

export interface SupportState {
  categories: GetCategoriesRes;
  categoryId: number;
  tipType: string;
  getCategoriesAction: AsyncState<GetCategoriesRes>;
  getTipsAction: AsyncState<GetTipsRes>;
  sendMessageAction: AsyncState<SendMessageRes>;
}
